var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isActive)?_c('div',{staticClass:"modal_overlay_off z-2000",class:{ modal_overlay_on: _vm.isActive },on:{"click":_vm.close}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }